<!--
 * @Author: your name
 * @Date: 2021-04-08 22:02:30
 * @LastEditTime: 2021-06-21 23:36:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\page\GoodList.vue
-->
<template>
    <div class="layout">
        <MainHeader />
        <UserNav />
        <div class="main_box">
            <el-main>
                <UserNavList />
                <div class="user_box">
                    <el-breadcrumb separator-class="el-icon-arrow-right"
                                   class="breadvrumb_box">
                        <el-breadcrumb-item :to="`/Center`">
                            首頁
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>我的資料</el-breadcrumb-item>
                    </el-breadcrumb>
                    <div class="user_div">
                        <div class="user_info">
                            <h3>修改資料</h3>
                            <div class="user_info_top">
                                <div class="user_avatar">
                                    <i class="iconfont icon-al-huazhuangpin"></i>
                                </div>
                                <div class="user_item_box">
                                    <div class="user_item user_tit">
                                        歡迎您~ <span>{{ user_data.user_name }}</span>
                                    </div>
                                    <div class="user_item">
                                        會員賬號：{{ user_data.user_id }}
                                    </div>
                                </div>
                            </div>
                            <div class="user_form_box">
                                <div class="form_info">
                                    <el-form ref="formValidate"
                                             :rules="ruleValidate"
                                             :model="form"
                                             label-width="100px">
                                        <el-form-item label="昵稱"
                                                      prop="name">
                                            <el-input v-model="form.name"></el-input>
                                        </el-form-item>
                                        <el-form-item label="郵箱"
                                                      prop="email">
                                            <el-input v-model="form.email"></el-input>
                                        </el-form-item>
                                        <el-form-item label="微信"
                                                      prop="wechat">
                                            <el-input v-model="form.wechat"></el-input>
                                        </el-form-item>
                                        <el-form-item label="LINE"
                                                      prop="line">
                                            <el-input v-model="form.line"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <div class="form_btn">
                                    <el-button type="primary"
                                               class="common_btn"
                                               @click="ChangeInfo()">
                                        修改
                                    </el-button>
                                    <el-button @click="resetForm('formValidate')">
                                        重置
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-main>
        </div>
        <MainFooter />
    </div>
</template>

<script>
import MainHeader from "@/components/Header";
import UserNav from "@/components/UserNav";
import UserNavList from "@/components/UserNavList";
import MainFooter from "@/components/Footer";
import { user_info, change_user_info } from "@/api/userAPI";
// 辅助函数，可以使用命名空间获取$store的数据
import { mapState } from "vuex";
export default {
    components: {
        MainHeader,
        UserNav,
        MainFooter,
        UserNavList,
    },
    data() {
        return {
            login_status: false,
            form: {
                name: null, // 昵称
                email: null, // 邮箱
                wechat: null, // 微信
                line: null, // Line
            },
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: "會員昵稱不能為空",
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        type: "email",
                        message: "請輸入正確的郵箱地址",
                        trigger: ["blur", "change"],
                    },
                ],
            },
        };
    },
    computed: {
        ...mapState("loginUser", ["user_data", "islogining"]),
    },
    created() {
        this.getUserInfo();
    },
    methods: {
        async getUserInfo() {
            let resp = await user_info();
            switch (resp.login_status) {
                case true:
                    this.form = resp.info;
                    break;
                case "note":
                    this.$message({
                        type: "error",
                        message: resp.msg,
                        center: true,
                    });
                    break;
                case "Login":
                    this.$message({
                        type: "error",
                        message: resp.msg,
                        center: true,
                    });
                    this.$router.push({ name: "Login" });
                    break;
                default:
                    console.log(resp);
                    break;
            }
        },
        ChangeInfo() {
            this.$refs["formValidate"].validate(async (val) => {
                if (val) {
                    let resp = await change_user_info(this.form);
                    switch (resp.OPStatus) {
                        case true:
                            this.$message({
                                type: "success",
                                message: "修改成功!",
                                center: true,
                            });
                            this.getUserInfo();
                            break;
                        case "note":
                            this.$message({
                                type: "error",
                                message: resp.msg,
                                center: true,
                            });
                            break;
                        case "Login":
                            this.$message({
                                type: "error",
                                message: resp.msg,
                                center: true,
                            });
                            this.$router.push({ name: "Login" });
                            break;
                        default:
                            console.log(resp);
                            break;
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: "輸入錯誤",
                        center: true,
                    });
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
};
</script>

<style scoped lang="scss">
.main_box {
    background: #f5f6f8 url("../../public/img/user-bg.jpg") center 0 no-repeat;
    min-height: 600px;
    height: auto;
    overflow: hidden;
    .el-main {
        width: 1000px;
        margin: 24px auto;
        padding: 0;
        background-color: rgba(255, 255, 255, 0);
        .user_box {
            float: right;
            width: 820px;
            min-height: 600px;
            _height: 600px;
            margin-bottom: 20px;
            .breadvrumb_box {
                margin: 8px 0 10px 0;
                border-left: 2px solid #ff2832;
                padding-left: 10px;
                height: 16px;
                line-height: 16px;
                ::v-deep .el-breadcrumb__inner.is-link:hover {
                    color: #ff2832;
                }
            }
            .user_div {
                background: #fff;
                border-color: #e4e4e4;
                border-width: 1px 1px 0 1px;
                border-style: solid;
                height: auto;
                .user_info {
                    background: #fff;
                    border-color: #e4e4e4;
                    border-width: 1px 1px 0 1px;
                    border-style: solid;
                    height: auto;
                    overflow: hidden;
                    border-top: 1px solid #ff2832;
                    h3 {
                        color: #333;
                        font-size: 14px;
                        font-weight: bolder;
                        padding: 18px 0 12px 20px;
                        border-bottom: 1px solid #dcdcdc;
                    }
                    .user_info_top {
                        margin: 0 25px;
                        padding: 24px 0;
                        position: relative;
                        height: auto;
                        overflow: hidden;
                        border-bottom: 1px solid #ececec;

                        .user_avatar {
                            float: left;
                            background-color: #fef0eb;
                            width: 92px;
                            height: 92px;
                            border-radius: 92px;
                            border: 4px solid #fff;
                            box-shadow: 2px 2px 2px #d8d7d7;
                            position: relative;
                            top: 0;
                            overflow: hidden;
                            i {
                                line-height: 100px;
                                display: block;
                                text-align: center;
                                font-size: 40px;
                                color: #f29d83;
                            }
                        }
                        .user_item_box {
                            float: left;
                            margin-left: 24px;
                            margin-top: 24px;
                            .user_item {
                                padding: 4px 0;
                                font-size: 14px;
                            }
                            .user_tit {
                                span {
                                    font-weight: bold;
                                }
                            }
                        }
                    }
                    .user_form_box {
                        margin: 0 25px;
                        .form_info {
                            padding: 25px 0;
                            border-bottom: 1px solid #ececec;
                            ::v-deep .el-form-item__content {
                                width: 300px;
                            }
                        }
                        .form_btn {
                            text-align: center;
                            margin: 20px auto 0;
                            padding-bottom: 30px;
                        }
                    }
                }
            }
        }
    }
}
</style>
